/**
 * Période d'essai maximale légale CDD / CDDU (article L1242-10 du Code du travail) :
 * 1 jour par semaine complète, plafond 14 j si contrat ≤ 6 mois, 30 j sinon.
 * Retourne 0 si les dates sont invalides ou si `end <= start`.
 */
export function computeMaxTrialDays(startIso, endIso) {
    if (!startIso || !endIso) return 0;
    const start = new Date(startIso);
    const end = new Date(endIso);
    if (isNaN(start) || isNaN(end) || end <= start) return 0;
    const durationDays = Math.floor((end - start) / 86400000);
    const weeks = Math.floor(durationDays / 7);
    const sixMonthsLater = new Date(start);
    sixMonthsLater.setMonth(sixMonthsLater.getMonth() + 6);
    const cap = end <= sixMonthsLater ? 14 : 30;
    return Math.max(1, Math.min(weeks, cap));
}
